$(".publicationPan .theme-omdia .followingrow [data-toggle='switch']").click(function(){
    $(this).toggleClass("active");
});